import { render } from "./BranchSummary.vue?vue&type=template&id=c4b1555e&scoped=true"
import script from "./BranchSummary.vue?vue&type=script&lang=js"
export * from "./BranchSummary.vue?vue&type=script&lang=js"

import "./BranchSummary.vue?vue&type=style&index=0&id=c4b1555e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b1555e"]])

export default __exports__